import { combineReducers } from "redux";
import authReducer from "./authReducer";
import walletReducer from "./walletReducer";
import athletesReducer from "./athletesReducer";
import authDataReducer from "./authDataReducer";
import changeAdminReducer from "./changeAdminReducer";
import subAdminReducer from "./subAdminReducer";
import pizzaMoneyReducer from "./pizzaMoneyReducer";
import managerReducer from "./managerReducer";
import contestReducer from "./contestReducer";
import notificationsReducer from "./notificationsReducer";
import SportsCommunityBadgeReducer from "./SportsCommunityBadgeReducer";

export const appReducer = combineReducers({
  auth: authReducer,
  wallet: walletReducer,
  athletes: athletesReducer,
  authData: authDataReducer,
  changeAdmin: changeAdminReducer,
  subAdminData: subAdminReducer,
  pizzaMoney: pizzaMoneyReducer,
  manager: managerReducer,
  contest: contestReducer,
  notifications: notificationsReducer,
  sportsCommunityBadge: SportsCommunityBadgeReducer,
});
const rootReducer = (state, action) => {
  if (action.type === "LOGOUT_SUCCESS") {
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};
export default rootReducer;
